// extracted by mini-css-extract-plugin
export var chatHtmlText = "_sz-2";
export var chatLink = "_sz-0";
export var chatText = "_sz-1";